export default "__VITE_ASSET__DN7GYh6___"